import type { HowItsCalculatedLineItem } from "./types";

export const HOW_ITS_CALCULATED_LINE_ITEMS: HowItsCalculatedLineItem[] = [
  { label: "Operating balance", value: "£8,420", variant: "default" },
  { label: "VAT to protect", value: "−£3,910", variant: "default" },
  { label: "VAT already protected", value: "£1,263", variant: "positive" },
  { label: "Unprotected VAT", value: "−£2,647", variant: "negative" },
];
